module.exports = __webpack_public_path__ + "static/media/sun_web.301bb0f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/websitesAndProjects/sun_web.jpg
// module id = 89
// module chunks = 0